import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(data) {
    var team_leader = "";
    // var team_leader = localStorage.getItem('role') =='team_leader' ? '/team':''
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        if (data[key] !== null && data[key] !== "" && data[key] !== undefined) {
          params += `${key}=${data[key]}&`;
        }
      });
    }
    return api.get(`/api/v1/pos${team_leader}?${params}`);
  },
  getAllList() {
    return api.post(`/api/v1/pos/list`);
  },
  getById(id) {
    return api.get(`/api/v1/pos/${id}`);
  },
  getByUserId(id) {
    return api.get(`/api/v1/pos/user/${id}`);
  },
  update(id, data) {
    return api.put(`/api/v1/pos/${id}`, data);
  },
  create(data) {
    var team_leader =
      localStorage.getItem("role") === "representative" ? "/create/by-rep" : "";
    return api.post(`/api/v1/pos${team_leader}`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/pos/${id}`);
  },
  export(data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        params += `${key}=${data[key]}&`;
      });
    }
    return api.get(`/api/v1/pos?${params}`, { responseType: "blob" });
  },
  getLastOpt(id) {
    return api.get(`/api/v1/user/last-otp/${id}`);
  },
  ePaymentFees(id, data) {
    return api.put(`/api/v1/pos/e-payment-fees/${id}`, data);
  },
  // The documents (ID card, residence card, signature, fingerprint...) are sent
  // as multipart on their own endpoint, one request carrying every changed file.
  uploadImages(id, formData) {
    return api.post(`/api/v1/pos-image/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  // Removing a single document: the slot to clear travels in the request body.
  deleteImage(id, name) {
    return api.delete(`/api/v1/pos-image/${id}`, { data: { name } });
  },
};
